import {CallJSSKey} from "@/Core/Bridge/CallJSSKey";
import Util from "@/Master/Util";
import GameMsgUtil from "@/app/(game)/GameMsgUtil";
import {GameMsgKey} from "@/app/(game)/GameMsgKey";
import {UserGlobalInfo} from "@/Core/Login/types/user";
import UserGlobalMgr from "@/Core/UserGlobalMgr";
import {RewardType} from "@/Core/Reward/RewardInfo";
import DataMgr from "@/Fwk/DataMgr";
import {KitConst} from "@/Fwk/Kit/KitConst";

export default class CallTempData {
    static tag: string = `[CallJSS-临时数据]`;


    static tempMap: Map<string, any> = new Map();


    static getVal(key:string){
        if (this.tempMap.has(key)){
            return this.tempMap.get(key);
        }
        return '';
    }

    static setVal(key:string,val:any){
        this.tempMap.set(key,val);
        if (Util.isLog){
            console.log(this.tag, `key=${key},val=${val}`);
        }
    }

    static get getHeaderStr(): string {
        let headerStr= this.getVal(CallJSSKey.Header);
        try {
            JSON.parse(headerStr);
            return headerStr;
        }catch (e) {
            const str = DataMgr.getStorage(KitConst.header_str,'');
            if (str){
                return str;
            }
        }
        return '';
    }

    static get getGameId(): number {
        let gameId = this.getVal(CallJSSKey.GameId);
        if (!gameId){
            const params = new URLSearchParams(window.location.search);
            gameId = params.get('game');
            gameId = Number(gameId);
        }
        return gameId;
    }

    static get getUserGlobalInfo(): UserGlobalInfo {
        const user = this.getVal(CallJSSKey.WebUserGlobalData) as UserGlobalInfo;
        if (!user?.baseInfo){
            return UserGlobalMgr.defaultUserInfo;
        }
        return user;
    }

    static get getRewardType(): string {
        return `${this.getUserGlobalInfo.rewardType}`;
    }

}